import { Hr_Race } from "@/graphql/gql/graphql";
import formatNumbersInThousands from "@/utils/horseRacing";
import styles from "./raceSubtitle.module.scss";

interface RaceSubtitleProps {
  race: Hr_Race;
  pursePrefix?: string;
}
const RaceSubtitle = ({ race, pursePrefix = "" }: RaceSubtitleProps) => (
  <div className={styles.container}>
    <div>{race?.type?.name}</div>
    <div>{race?.numRunners} Runners</div>
    <div>{race?.distance}</div>
    <div>{race?.raceClass?.name}</div>
    <div>{race?.surface?.name}</div>
    <div>{race?.surface?.defaultCondition}</div>
    {race.purse ? (
      <div>{`${pursePrefix}${formatNumbersInThousands(race.purse)}`}</div>
    ) : (
      ""
    )}
  </div>
);

export default RaceSubtitle;
